export function isDateToday(date: Date) {
  return new Date().toLocaleDateString() === date.toLocaleDateString();
}
